export default "__VITE_ASSET__C4dwO_jh__"